<span>
  <div class="employee-profile-wrapper">
    <div class="employee-profile">
      <div class="image-container">
        <img
          [ngStyle]="{ borderLeft: getBorderColor() }"
          id="user_image"
          [src]="imageSrc || '/assets/images/employee_placeholder.jpg'"
          loading="lazy"
        />
      </div>
      <p>
        {{
          employee?.employeeAlias !== '' && employee?.employeeAlias !== null
            ? employee.employeeAlias
            : employee.firstName + ' ' + employee.lastName
        }}
      </p>
    </div>
  </div>
</span>
